import { DatePickerComponent, Inject, MaskedDateTime } from '@syncfusion/ej2-react-calendars';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import moment from 'moment';
import { Row, Col } from 'react-bootstrap';

import styles from 'components/ProviderData/IpaAdministration/organisms/IpaAdministrationWizard/IpaAdministrationWizardPBPInfo.module.css';

type IpaAdministrationWizardPBPInfoProps = {
    ipa: any;
    asyncDebounce: any;
    checkIpaCode: any;
    register: any;
    setValue: any;
    getValues: any;
    errors: Record<string, any>;
    risks: Record<string, any>;
    types: Record<string, any>;
    termed: string | undefined;
    mso: Record<string, any>;
    contractCodes: any;
    fetchPbpCodes: any;
    pbpList: any;
    ipaPlan: any;
};

const IpaAdministrationWizardPBPInfo = (props: IpaAdministrationWizardPBPInfoProps) => {
    return (
        <div className='infoStepsMainWrap'>
            <div className='accordion-content'>
                <Row>
                    <Col
                        md={12}
                        className={`${styles['info-steps-wrapper']} px-4`}
                    >
                        <div className='infoStepsWrap'>
                            <p className='section-container-header mx-0'>PBP Info</p>
                        </div>
                        {props?.ipa?.ipaCode && (
                            <Row className='mb-3'>
                                <Col md='6'>
                                    <div>
                                        <div className={`e-float-input`}>
                                            <label>IPA Code</label>
                                            <br />
                                            <label>{props?.ipa?.ipaCode}</label>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col md={3}>
                                <div className={`${styles['date-picker']} datepicker e-input-group-margin`}>
                                    <label className='e-label-select'>Start Date *</label>
                                    <DatePickerComponent
                                        format='MM/dd/yyyy'
                                        enableMask={true}
                                        id='calendar_start'
                                        {...props?.register('pbpStartDate', {
                                            required: 'Start Date is required',
                                        })}
                                        change={({ value }) => props?.setValue('pbpStartDate', value)}
                                        min={undefined}
                                        max={new Date(9999, 11, 31)}
                                        strictMode
                                    >
                                        <Inject services={[MaskedDateTime]} />
                                    </DatePickerComponent>
                                    {props?.errors?.pbpStartDate && (
                                        <span className='error-form'>{props.errors.pbpStartDate.message}</span>
                                    )}
                                </div>
                            </Col>

                            <Col md={3}>
                                <div className={`${styles['date-picker']} datepicker e-input-group-margin`}>
                                    <label className='e-label-select'>End Date *</label>
                                    <DatePickerComponent
                                        format='MM/dd/yyyy'
                                        enableMask={true}
                                        id='calendar_end'
                                        {...props?.register('pbpEndDate', {
                                            required: 'End Date is required',
                                            validate: (value) => {
                                                const pbpStartDate = moment(new Date(props?.getValues('pbpStartDate')));
                                                const pbpEndDate = moment(new Date(props?.getValues('pbpEndDate')));
                                                if (value && pbpStartDate && pbpEndDate.isBefore(pbpStartDate)) {
                                                    return `End date must be Greater than start Date`;
                                                }
                                            },
                                        })}
                                        change={({ value }) => props?.setValue('pbpEndDate', value)}
                                        min={undefined}
                                        max={new Date(9999, 11, 31)}
                                        strictMode
                                    >
                                        <Inject services={[MaskedDateTime]} />
                                    </DatePickerComponent>
                                    {props?.errors?.pbpEndDate && (
                                        <span className='error-form'>{props?.errors.pbpEndDate.message}</span>
                                    )}
                                </div>
                            </Col>

                            <Col md={3}>
                                <div className={`${styles['date-picker']} datepicker e-input-group-margin`}>
                                    <label className='e-label-select'>Contract Code *</label>
                                    <DropDownListComponent
                                        id='contractCode'
                                        dataSource={props?.contractCodes}
                                        value={props?.contractCodes && props?.getValues('contractCode')}
                                        placeholder='Select a Contract Code'
                                        fields={{ text: 'text', value: 'id' }}
                                        change={({ itemData }) => {
                                            props?.setValue('contractCode', itemData.value);
                                            props?.fetchPbpCodes(itemData.value);
                                        }}
                                        popupHeight='220px'
                                        {...props?.register('contractCode', { required: 'Contract Code is required' })}
                                    />
                                    {props?.errors?.contractCode && (
                                        <span className='error-form'>{props.errors.contractCode.message}</span>
                                    )}
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className={`${styles['date-picker']} datepicker e-input-group-margin`}>
                                    <label className='e-label-select'>PBP Code *</label>
                                    <DropDownListComponent
                                        id='pbp'
                                        dataSource={props?.pbpList}
                                        value={props?.getValues().pbp}
                                        placeholder='Select a PBP Code'
                                        change={({ value }) => {
                                            props?.setValue('pbp', value);
                                        }}
                                        {...props?.register('pbp', {
                                            required: 'PBP Code is required',
                                        })}
                                    />
                                    {props?.errors?.pbp && (
                                        <span className='error-form'>{props.errors.pbp.message}</span>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default IpaAdministrationWizardPBPInfo;
